import React from "react";
import styled, { css } from "styled-components";
import LinkButton from "../LinkButton";
import { iOSAppPostMessage, isIronTerminal, isIronTerminalIosApp } from '../utils';

const SentContainer = styled.div`
  position: relative;
  display: table;
  vertical-align: top;
  width: 480px;
  margin-left: 212px;
  padding: 125px 0;

  ${props =>
    props.mobile &&
    css`
    display: table;
    vertical-align: middle;
    width: 100%;
    margin-top: 55px;
    margin-left: 0px;
    padding: 0px;
    background: transparent;
    @media (min-width: 480px) {
      margin-top: 5%;
    }
    @media (min-width: 736px) {
      margin-top: 8%;
    }
  `}
`;

const SentTitle = styled.h2`
  position: relative;
  margin: 0px;
  padding: 63px 0 0 0;
  font-weight: 300;
  font-size: 30px;
  line-height: 1.5;
  text-decoration: none;
  text-align: center;
  color: #60a31c;
  :before {
    content: "";
    position: absolute;
    top: 0px;
    left: 50%;
    width: 17px;
    height: 38px;
    border-right: 3px solid #60a31c;
    border-bottom: 3px solid #60a31c;
    transform: translateX(-50%) rotate(45deg);
  }

  ${props =>
    props.mobile &&
    css`
    padding-top: 76px;
    font-weight: 400;
    font-size: 18px;
    line-height: 1;
    :before {
      width: 24px;
      height: 48px;
      border-right: 4px solid #60a31c;
      border-bottom: 4px solid #60a31c;
      @media (max-width: 320px) {
        transform: translateX(-50%) rotate(45deg) scale(0.9);
      }
    }
    @media (max-width: 320px) {
      font-size: 16px;
    }
  `}
`;

const SentSubtitle = styled.p`
  margin: 20px 0 30px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  color: #343434;

  ${props =>
    props.mobile &&
    css`
    margin: 10px 0 20px;
    font-size: 16px;
    color: ${props => props.theme.mainFontColor};
    @media (max-width: 320px) {
      font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
    }
  `}
`;

const SentButtonContainer = styled.div`
  text-align: center;

  ${props =>
    props.mobile &&
    css`
    max-width: 410px;
    margin: 0 auto;
    @media(max-width: 479px) {
      margin-top: 100px;
    }
  `}
`;

const OfflineConfirmed = ({ desktop, title, message, tradeTitle, isIOS2 }) =>
  <SentContainer mobile={!desktop} style={desktop ? { minHeight: 576 } : null}>
    <SentTitle mobile={!desktop}>
      {title}
    </SentTitle>
    <SentSubtitle mobile={!desktop}>
      {message}
    </SentSubtitle>
    <SentButtonContainer mobile={!desktop}>
      <LinkButton
        onClick={(e) => {
          if (isIOS2 || isIronTerminal() || isIronTerminalIosApp) {
            e && e.preventDefault();
            iOSAppPostMessage("gotoTrade");
          }
        }}
        to="/trade"
        text={tradeTitle}
        type="yellow"
        bigfckinbutton={desktop}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: 410
        }}
      />
    </SentButtonContainer>
  </SentContainer>;

export default OfflineConfirmed;



// WEBPACK FOOTER //
// ./src/components/OfflinePopup/OfflineConfirmed.js